interface Properties {
  width?: number;
  height?: number;
  color?: string;
}

const LogoutIcon = ({ width = 20, height = 20, color = '#745BE3' }: Properties) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M6.66667 0C3.90917 0 1.66667 2.2425 1.66667 5C1.66667 7.7575 3.90917 10 6.66667 10C9.42417 10 11.6667 7.7575 11.6667 5C11.6667 2.2425 9.42417 0 6.66667 0ZM6.66667 8.33333C4.82833 8.33333 3.33333 6.83833 3.33333 5C3.33333 3.16167 4.82833 1.66667 6.66667 1.66667C8.505 1.66667 10 3.16167 10 5C10 6.83833 8.505 8.33333 6.66667 8.33333ZM9.16 12.6558C9.10333 13.1117 8.69083 13.4375 8.23 13.3792C7.99083 13.3492 7.7475 13.3342 7.5 13.3342C4.28417 13.3342 1.66667 15.9508 1.66667 19.1675C1.66667 19.6275 1.29417 20.0008 0.833333 20.0008C0.3725 20.0008 0 19.6275 0 19.1675C0 15.0325 3.36417 11.6675 7.5 11.6675C7.81417 11.6675 8.12917 11.6867 8.43667 11.7258C8.89417 11.7833 9.2175 12.1983 9.16 12.6558ZM15 19.1667C15 19.6267 14.6275 20 14.1667 20H13.3333C11.955 20 10.8333 18.8783 10.8333 17.5V12.5C10.8333 11.1217 11.955 10 13.3333 10H14.1667C14.6275 10 15 10.3733 15 10.8333C15 11.2933 14.6275 11.6667 14.1667 11.6667H13.3333C12.8733 11.6667 12.5 12.0408 12.5 12.5V17.5C12.5 17.9592 12.8733 18.3333 13.3333 18.3333H14.1667C14.6275 18.3333 15 18.7067 15 19.1667ZM19.9967 15.0175C19.9967 15.47 19.8217 15.86 19.4975 16.1417L17.665 17.7575C17.5075 17.8967 17.31 17.9658 17.1142 17.9658C16.8842 17.9658 16.6533 17.8708 16.4892 17.6833C16.185 17.3383 16.2183 16.8117 16.5633 16.5075L17.3275 15.8333H15.0008C14.54 15.8333 14.1675 15.46 14.1675 15C14.1675 14.54 14.54 14.1667 15.0008 14.1667H17.2158L16.5633 13.5908C16.2183 13.2867 16.185 12.76 16.4892 12.415C16.7933 12.0692 17.3225 12.0383 17.665 12.3408L19.5042 13.9625C19.8117 14.2242 19.9967 14.6192 19.9967 15.0175Z'
        fill={color}
      />
    </svg>
  );
};

export default LogoutIcon;
